exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".runcode-btn_btn_1eRZQ {\r\n    width: 21px;\r\n    height: 21px;\r\n    -webkit-user-select: none;\r\n       -moz-user-select: none;\r\n        -ms-user-select: none;\r\n            user-select: none;\r\n    cursor: pointer;\r\n    -webkit-transition: 0.2s ease-out;\r\n    transition: 0.2s ease-out;\r\n}\r\n\r\n\r\n.runcode-btn_btn_1eRZQ:hover {\r\n    -webkit-transform: scale(1.2);\r\n        -ms-transform: scale(1.2);\r\n            transform: scale(1.2);\r\n}\r\n\r\n\r\n.runcode-btn_btn_1eRZQ.runcode-btn_is-active_1xkwg {\r\n    opacity: 1;\r\n}\r\n", ""]);

// exports
exports.locals = {
	"btn": "runcode-btn_btn_1eRZQ",
	"is-active": "runcode-btn_is-active_1xkwg",
	"isActive": "runcode-btn_is-active_1xkwg"
};